(()=>{const body=document.body;if(!body)return;
const conn=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
const constrained=!!(conn&&(conn.saveData||/2g/.test(conn.effectiveType||'')));
const fine=matchMedia('(hover:hover) and (pointer:fine)');
const prefetched=new Set();
const productHref=a=>{
  if(!a||constrained)return null;
  let u;
  try{u=new URL(a.href,location.href)}catch(e){return null}
  if(u.origin!==location.origin||u.pathname===location.pathname||!u.pathname.startsWith('/products/'))return null;
  u.hash='';
  return u.href;
};
const prefetchHref=href=>{
  if(!href||prefetched.has(href)||prefetched.size>=6)return;
  prefetched.add(href);
  const link=document.createElement('link');
  link.rel='prefetch';
  link.href=href;
  link.fetchPriority='low';
  document.head.appendChild(link);
};
if(fine.matches&&!constrained){
  let hoverTimer=0;
  document.addEventListener('pointerover',event=>{
    const a=event.target.closest?.('a[href]');
    if(!a||a.contains(event.relatedTarget))return;
    const href=productHref(a);
    if(!href)return;
    clearTimeout(hoverTimer);
    hoverTimer=setTimeout(()=>prefetchHref(href),110);
  },{passive:true});
  document.addEventListener('pointerout',event=>{
    const a=event.target.closest?.('a[href]');
    if(a&&!a.contains(event.relatedTarget))clearTimeout(hoverTimer);
  },{passive:true});
}else if(!constrained&&'IntersectionObserver'in window){
  const warmVisible=()=>{
    const links=[...document.querySelectorAll('a[href]')].filter(a=>productHref(a)).slice(0,24);
    if(!links.length)return;
    let warmed=0;
    const observer=new IntersectionObserver(entries=>{
      for(const entry of entries){
        if(!entry.isIntersecting)continue;
        observer.unobserve(entry.target);
        const href=productHref(entry.target);
        if(href){prefetchHref(href);warmed++}
        if(warmed>=2){observer.disconnect();break}
      }
    },{rootMargin:'220px 0px',threshold:.01});
    links.forEach(a=>observer.observe(a));
  };
  if('requestIdleCallback'in window)requestIdleCallback(warmVisible,{timeout:1800});
  else setTimeout(warmVisible,700);
}

const key='valuraa_recent_searches_v1';
const read=()=>{try{const v=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(v)?v.slice(0,5):[]}catch(e){return[]}};
const save=q=>{q=(q||'').trim();if(q.length<2)return;const next=[q,...read().filter(x=>x.toLowerCase()!==q.toLowerCase())].slice(0,5);try{localStorage.setItem(key,JSON.stringify(next))}catch(e){}};
const dialog=document.querySelector('[data-vfh3-search]');
const input=dialog?.querySelector('[data-vfh3-search-input]');
const form=dialog?.querySelector('.vfh2-search__form');
const popular=dialog?.querySelector('[data-vfh3-popular]');
const fire=q=>{if(!input)return;input.value=q;input.focus({preventScroll:true});input.dispatchEvent(new Event('input',{bubbles:true}))};
const renderRecent=()=>{
  if(!dialog||!form)return;
  dialog.querySelector('.vl-perf-recent')?.remove();
  const values=read();
  if(!values.length)return;
  const wrap=document.createElement('div');
  wrap.className='vl-perf-recent';
  const label=document.createElement('p');
  label.className='vl-perf-recent__label';
  label.textContent=body.dataset.vlRecentLabel||'Recent searches';
  const chips=document.createElement('div');
  chips.className='vl-perf-recent__chips';
  const fragment=document.createDocumentFragment();
  values.forEach(q=>{const b=document.createElement('button');b.type='button';b.textContent=q;b.addEventListener('click',()=>fire(q));fragment.appendChild(b)});
  chips.appendChild(fragment);
  wrap.append(label,chips);
  form.after(wrap);
};
form?.addEventListener('submit',()=>save(input?.value));
dialog?.addEventListener('click',event=>{const result=event.target.closest?.('.vfps-results__item,.vfps-results__all');if(result)save(input?.value)});
popular?.addEventListener('click',event=>{const a=event.target.closest('a');if(!a||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();const q=(a.textContent||'').trim();if(q){fire(q);save(q);renderRecent()}});
document.querySelectorAll('[data-vfh3-search-open]').forEach(button=>button.addEventListener('click',()=>requestAnimationFrame(renderRecent)));
})();